import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
export const homeCardWrapper = "odules__Home__components__HomeCard_styles_ts-homeCardWrapper-h1ishual";
export const homeCardHeader = "odules__Home__components__HomeCard_styles_ts-homeCardHeader-h84bn8b";
export const homeCardTitleWrapper = "odules__Home__components__HomeCard_styles_ts-homeCardTitleWrapper-h1hk0mnq";
export const homeCardTitle = "odules__Home__components__HomeCard_styles_ts-homeCardTitle-hm8fq87";
export const homeCardDescription = "odules__Home__components__HomeCard_styles_ts-homeCardDescription-hv50qzc";

require("./HomeCard.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./HomeCard.styles.ts");